<template>
  <v-btn @click="this.$router.push('/')" elevation="0" icon
    ><v-icon color="red-darken-4">mdi-arrow-left</v-icon></v-btn
  >

  <div
    class="d-flex justify-center align-center pb-15"
    style="min-height: 90vh"
  >
    <v-col cols="12" md="6">
      <v-card width="100%" :elevation="mdAndUp ? '1' : '0'" class="pb-5">
        <v-col cols="12" class="text-center">
          <v-col>
            <v-avatar
              size="150"
              rounded="0"
              style="box-shadow: 0 4px 4px -1px rgb(94, 95, 95)"
            >
              <v-img :src="this.dadosEmpresa.img_url"></v-img>
            </v-avatar>
          </v-col>
          <v-col>
            {{ this.dadosEmpresa.nome }}
          </v-col>
        </v-col>
        <v-col class="text-center">
          <h3>
            {{
              this.$router.currentRoute.value.fullPath == "/registro"
                ? "Registro"
                : "Login"
            }}
          </h3>
        </v-col>
        <v-col
          cols="12"
          md="7"
          class="mx-auto"
          v-if="this.$router.currentRoute.value.fullPath != '/registro'"
        >
          <v-form ref="formLogin" @submit.prevent="login()" class="text-center">
            <v-text-field
              v-model="user"
              variant="underlined"
              label="E-mail"
              color="red"
              clearable
              required
              :rules="[
                (val) => /.+@.+/.test(val) || 'Email precisa ser válido',
              ]"
              clear-icon="mdi-close"
            ></v-text-field>
            <v-text-field
              v-model="password"
              label="Senha"
              variant="underlined"
              :type="show1 ? 'text' : 'password'"
              color="red"
              :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              clearable
              clear-icon="mdi-close"
              required
              :error-messages="mensagemErroSenha"
              :rules="[
                (val) => val != '' || 'Insira sua senha',
                (val) => val != null || 'Insira sua senha',
                (val) => val != undefined || 'Insira sua senha',
              ]"
              @click:append-inner="show1 = !show1"
            >
            </v-text-field>
            <v-btn color="green darken-4" rounded="xl" type="submit"
              >Acessar Plataforma</v-btn
            >
          </v-form>
        </v-col>
        <v-col cols="12" md="7" class="mx-auto" v-else>
          <v-form
            ref="formRegistro"
            @submit.prevent="register()"
            class="text-center"
          >
            <v-text-field
              clearable
              clear-icon="mdi-close"
              v-model="registro.cpf"
              pattern="[0-9]*"
              counter
              placeholder="999.999.999-99"
              maxlength="11"
              minlength="11"
              label="CPF (Somente Números)"
              required
              variant="underlined"
              :rules="[
                (val) => val != '' || 'Cpf Inválido',
                (val) => val != null || 'Cpf Inválido',
                (val) =>
                  val != null
                    ? (val.length != 14 && this.validaCpf()) || 'Cpf Inválido'
                    : '',
              ]"
              color="red"
            ></v-text-field>
            <v-text-field
              clearable
              clear-icon="mdi-close"
              v-model="registro.nome"
              label="Nome"
              required
              :rules="[
                (val) =>
                  (RegExp(
                    '^[A-Za-z0-9-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ,.()\n ]*$',
                  ).test(val) &&
                    !RegExp('[ ]{2,}').test(val)) ||
                  'Nome Inválido, verifique espaçamento e caracteres',
                (val) => val != '' || 'Insira seu nome',
                (val) => val != null || 'Insira seu nome',
                (val) => val != undefined || 'Insira seu nome',
              ]"
              variant="underlined"
              color="red"
            ></v-text-field>
            <v-text-field
              clearable
              clear-icon="mdi-close"
              v-model="registro.sobrenome"
              label="Sobrenome"
              required
              :rules="[
                (val) =>
                  (RegExp(
                    '^[A-Za-z0-9-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ,.()\n ]*$',
                  ).test(val) &&
                    !RegExp('[ ]{2,}').test(val)) ||
                  'Sobrenome Inválido, verifique espaçamento e caracteres',
                (val) => val != '' || 'Insira seu sobrenome',
                (val) => val != null || 'Insira seu sobrenome',
                (val) => val != undefined || 'Insira seu sobrenome',
              ]"
              variant="underlined"
              color="red"
            ></v-text-field>

            <v-text-field
              clearable
              clear-icon="mdi-close"
              v-model="registro.telefone"
              label="Celular (somente numeros)"
              variant="underlined"
              color="red"
              counter
              placeholder="(99) 9999-99999"
              maxlength="16"
              minlength="14"
              required
              :rules="[
                (val) => val != null || 'Digite seu número de telefone',
                (val) => val != '' || 'Digite seu número de telefone',
                (val) => val != undefined || 'Digite seu número de telefone',
                (val) => val.length >= 14 || 'Número inválido',
              ]"
            ></v-text-field>
            <v-text-field
              clearable
              clear-icon="mdi-close"
              v-model="registro.cidade"
              label="Cidade"
              variant="underlined"
              disabled
              color="red"
            ></v-text-field>
            <v-text-field
              clearable
              clear-icon="mdi-close"
              v-model="registro.cep"
              maxlength="9"
              minlength="9"
              counter
              :label="'Cep (somente números)'"
              required
              :rules="[
                (val) => val != null || 'Digite seu cep',
                (val) => val != '' || 'Digite seu cep',
                (val) => val != undefined || 'Digite seu cep',
                (val) => val.length >= 9 || 'Cep inválido',
              ]"
              variant="underlined"
              color="red"
            >
            </v-text-field>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  clearable
                  clear-icon="mdi-close"
                  v-model="registro.endereco"
                  label="Endereço"
                  required
                  :rules="[
                    (val) => val != '' || 'Insira seu endereco',
                    (val) => val != null || 'Insira seu endereco',
                    (val) => val != undefined || 'Insira seu endereco',
                  ]"
                  variant="underlined"
                  color="red">
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  clearable
                  clear-icon="mdi-close"
                  v-model="registro.numero"
                  label="Número"
                  required
                  :rules="[
                    (val) => val != '' || 'Insira o número',
                    (val) => val != null || 'Insira o número',
                    (val) => val != undefined || 'Insira o número',
                    (val) => /^[a-zA-Z0-9 .]*$/.test(val) || 'Número Inválido',
                    !RegExp('[ ]{2,}').test(val) || 'Número Inválido',
                    (val) => val.length <= 8 || 'Número inválido',
                  ]"
                  variant="underlined"
                  color="red">
                </v-text-field>
                
              </v-col>
            </v-row>
            <v-text-field
              clearable
              clear-icon="mdi-close"
              v-model="registro.complemento"
              label="Complemento (Se não necessitar, deixar vazio)"
              required
              :rules="[
                (val) => val != null || 'Insira o complemento',
                (val) => val != undefined || 'Insira o complemento',
                (val) => /^[a-zA-Z0-9 .]*$/.test(val) || 'Complemento Inválido',
                !RegExp('[ ]{2,}').test(val) || 'Complemento Inválido',
              ]"
              variant="underlined"
              color="red">
            </v-text-field>
            <v-autocomplete
              clearable
              clear-icon="mdi-close"
              v-model="registro.bairro"
              label="Bairro"
              required
              :rules="[
                (val) => val != null || 'Selecione um Bairro',
                (val) => val != '' || 'Selecione um Bairro',
              ]"
              variant="underlined"
              color="red"
              :items="bairros"
              :item-title="(item) => item.nome"
              :item-value="(item) => item"
              density="comfortable"
              max-height="50px"
            ></v-autocomplete>
            <v-text-field
              v-model="registro.user"
              variant="underlined"
              label="E-mail"
              color="red"
              clearable
              required
              :rules="[
                (val) => /.+@.+/.test(val) || 'Email precisa ser válido',
              ]"
              clear-icon="mdi-close"
            ></v-text-field>
            <v-text-field
              :rules="[
                (val) =>
                  val.length >= 8 ||
                  'A senha precisa conter no mínimo 8 caracteres.',
              ]"
              v-model="registro.password"
              label="Senha"
              variant="underlined"
              :type="show1 ? 'text' : 'password'"
              color="red"
              :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              clearable
              clear-icon="mdi-close"
              :error-messages="mensagemErroSenha"
              required
              @click:append-inner="show1 = !show1"
            >
            </v-text-field>

            <v-btn color="green darken-4" rounded="xl" type="submit"
              >Concluir Registro</v-btn
            >
          </v-form>
        </v-col>
        <div
          v-if="this.$router.currentRoute.value.fullPath != '/registro'"
          class="text-center"
          color="red darken-4"
          variant="text"
        >
          Nao Possui Registro?
          <a
            style="cursor: pointer"
            variant="text"
            class="text-body-2 font-weight-bold"
            @click="
              this.$router.push('/registro'),
                (registro.user = user),
                (registro.password = password),
                (mensagemErroSenha = '')
            "
          >
            Criar Conta
          </a>
        </div>
        <div v-else class="text-center" color="red darken-4" variant="text">
          Já Possui Registro?
          <a
            style="cursor: pointer"
            variant="text"
            class="text-body-2 font-weight-bold"
            @click="this.$router.push('/login')"
          >
            Acessar Conta
          </a>
        </div>
      </v-card>
    </v-col>
  </div>
  <div class="powered-by">
    <div>
      <span>Powered by </span>
    </div>
    <div>
      <img
        :src="image"
        alt="ibologo"
        style="height: 90px; margin-top: -25%; margin-bottom: -25%"
      />
    </div>
  </div>
  <v-dialog>
    <v-card> </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import { useDisplay } from "vuetify";
import LoginUser from "../../libs/login";
import createUser from "../../libs/createUser";
import { store } from "../../store/store";
import axios from "axios";
import stringSimilarity from "string-similarity";
import { maskJs } from "mask-js";

var image = require("../../assets/logowithtext.svg");

export default {
  name: "loginUser",

  data: () => ({
    maskTel: "",
    registro: {
      user: "",
      password: "",
      cpf: "",
      endereco: "",
      complemento: "",
      numero: "",
      bairro: "",
      cidade: "Passo Fundo",
      nome: "",
      whatsapp: "",
      telefone: "",
      sobrenome: "",
    },
    show1: false,
    user: "",
    password: "",
    mensagemErroSenha: "",
    image: image,
  }),
  setup() {
    // Destructure only the keys we want to use
    const { xs, mdAndUp } = useDisplay();

    return { xs, mdAndUp };
  },
  watch: {
    "registro.telefone"(n) {
      const cleanedPhone = n.replace(/\D/g, "");
      if (cleanedPhone.length > 10) {
        this.registro.telefone = maskJs("(99) 9 9999-9999", n);
      } else {
        this.registro.telefone = maskJs("(99) 9999-9999", n);
      }
    },
    async "registro.cep"(n) {
      const cleanCep = n.replace(/\D/g, "");
      this.registro.cep = maskJs("99999-999", n);
      if (n.length == 9) {
        {
          const response = await axios({
            method: "get",
            url: `https://viacep.com.br/ws/${cleanCep}/json/`,
          });
          this.registro.endereco = response.data.logradouro;
          this.registro.bairro = this.matchBairro(response);
        }
      }
    },
  },

  computed: {
    ...mapGetters([
      "selecionadoCategorias",
      "database",
      "dadosEmpresa",
      "carrinho",
      "pedidos",
      "produtos",
      "categorias",
      "horario",
      "busca",
      "disableDelivery",
      "disableEncomenda",
      "combos",
      "shownAlert",
      "bairros",
    ]),
  },
  methods: {
    matchBairro(response) {
      const bairroNames = this.bairros.map((bairro) => bairro.nome);
      const matches = stringSimilarity.findBestMatch(
        response.data.bairro,
        bairroNames,
      );

      const bestMatch = matches.bestMatch.target;
      const matchedBairro = this.bairros.find(
        (bairro) => bairro.nome === bestMatch,
      );

      return matchedBairro;
    },
    async login() {
      this.$refs.formLogin.validate().then((val) => {
        if (val.valid) {
          this.mensagemErroSenha = "";
          LoginUser(this.user, this.password).then((n) => {
            if (n.data.message == "Usuário Inexistente ou Inválido.") {
              this.mensagemErroSenha = "Usuário Inexistente ou Inválido.";
            } else if (n.data.message == "Senha Incorreta.") {
              this.mensagemErroSenha = "Senha Incorreta.";
            } else {
              store.commit("incrementLogado", n.data);
              this.$router.push("/");
            }
          });
        }
      });
    },
    register() {
      this.$refs.formRegistro.validate().then((val) => {
        if (val.valid) {
          this.mensagemErroSenha = "";
          this.registro.whatsapp =
            "55" + this.registro.telefone.replace(/[() -]/g, "");
          createUser(this.registro).then((n) => {
            if (n.data.message == "Usuário Existente.") {
              this.mensagemErroSenha = '"Usuário Existente.';
            } else if (n.data.message == "Cpf já cadastrado.") {
              this.mensagemErroSenha = "Cpf já cadastrado.";
            } else {
              this.$router.push("/login");
              this.$swal.fire({
                icon: "success",
                title: "Usuario Criado",
                text: "Realize Login com as credenciais cadastradas.",
                showConfirmButton: false,
                timer: 2000,
              });
            }
          });
        }
      });
    },
    validaCpf() {
      if (this.registro.cpf.length == 11) {
        var cpf = this.registro.cpf.trim();
        var p = 0;
        var i = 0;
        var v1 = 0;
        var v2 = 0;
        var aux = false;

        for (i = 1; cpf.length > i; i++) {
          if (cpf[i - 1] != cpf[i]) {
            aux = true;
          }
        }

        if (aux == false) {
          return false;
        }

        for (i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
          v1 += cpf[i] * p;
        }

        v1 = (v1 * 10) % 11;

        if (v1 == 10) {
          v1 = 0;
        }

        if (v1 != cpf[9]) {
          return false;
        }

        for (i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
          v2 += cpf[i] * p;
        }

        v2 = (v2 * 10) % 11;

        if (v2 == 10) {
          v2 = 0;
        }

        if (v2 != cpf[10]) {
          return false;
        } else {
          return true;
        }
      }
    },
  },

  async created() {},
  mounted() {},
  activated() {
    if (!localStorage.getItem("cookiesEnabled")) {
      this.$swal
        .fire({
          position: "bottom",
          showDenyButton: true,
          title: "O nosso site usa cookies",
          text: "Utilizamos cookies e outras tecnologias melhorar a sua experiência de navegação no nosso site, de forma a que se faz necessario a permissao do armazenamento para que a funcionalidade de login seja disponbilizada.",
          confirmButtonColor: "green",
          denyButtonColor: "red",
          confirmButtonText: "Concordo",
          denyButtonText: `Eu recuso`,
        })
        .then((n) => {
          if (n.isConfirmed == true) {
            localStorage.setItem("cookiesEnabled", true);
          } else {
            this.$router.push("/");
          }
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.powered-by {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  padding: -8px;
}
</style>
